module.exports = __webpack_public_path__ + "static/media/invalid-name@2x.81c0674b.png";